import React, { Dispatch, ReactElement, useEffect, useState } from 'react'
import rainLayer from "../assets/rainLayer.png";
import { useMapLayersContext } from '../provider/MapLayers';
import { LocationMarkerPopup } from "../mainLayer/MainWindow";

type LayerRainPropsType = {
    name: string;
    color?: string;
}

const LayerRain = (props: LayerRainPropsType) => {
    const { selectLayerInMap, loadLayerInMap,setIsRainLoad } = useMapLayersContext();
    const [isSelectedRain, setIsSelectedRain] = useState<boolean>(false)
      
        useEffect(() => {
          if(loadLayerInMap === "rain"){
            setIsSelectedRain(true);
            }else if(loadLayerInMap !== "rain"){
                setIsSelectedRain(false);
            }
        }, [loadLayerInMap]);


          const RainIconClick = () => {
            if (!isSelectedRain) {
              selectLayerInMap("rain");
            } else {
              selectLayerInMap("rainnot");
            }
            setIsRainLoad(false);
          };

    return (
        <div className={`subItemWrapper`}   onClick={(e) => RainIconClick()} onTouchStart={(e) => RainIconClick()}>
                {props.color && (
                    <div className={`colorBox ${isSelectedRain ? 'selected' : ''}`} style={{backgroundColor: `${props.color}`}}></div>
                )}

                <div className={`colorBox ${isSelectedRain ? 'selected' : ''}`}>
                    <img src={rainLayer} alt="" />
                </div>

                <span>{props.name}</span>
     
            </div>
    )
}

export default LayerRain;